import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useState } from "react";

type Props = {
  text: string;
};

export const CopyButton = ({ text }: Props) => {
  const { t } = useResource();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    } catch (error) {
      console.error(error);
    }
  };

  const label = t(isCopied ? Resources.Common.Copied : Resources.Common.Copy);

  return (
    <Tooltip title={label}>
      <IconButton size="small" aria-label={label} onClick={handleCopy}>
        {isCopied ? <CheckIcon fontSize="inherit" color="success" /> : <ContentCopyIcon fontSize="inherit" />}
      </IconButton>
    </Tooltip>
  );
};
